module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-book-detail/arrow-left-5126545263faa7d03a6a2fcf92a0074a.svg";